import { defineMessages } from 'react-intl';

export default defineMessages({
  getStartedHeader: {
    id: 'rewards.sr6RewardsPage.getStarted.getStartedHeader',
    defaultMessage: "It's Easy to Get Started",
    description: 'Header for SR6 Get Started section',
  },
  getStartedBody: {
    id: 'rewards.sr6RewardsPage.getStarted.getStartedBody',
    defaultMessage:
      'To get started, <joinNow>join now</joinNow>. You can also { joinInApp } to get access to the full range of Starbucks® Rewards benefits.',
    description: 'Body for SR6 Get Started section',
  },
  orderAndPay: {
    id: 'rewards.sr6RewardsPage.getStarted.orderAndPay',
    defaultMessage: 'Order and pay',
    description: 'H3 for Get Started section',
  },
  earnStarsGetRewards: {
    id: 'rewards.sr6RewardsPage.getStarted.earnStarsGetRewards',
    defaultMessage: 'Earn Stars, get Rewards',
    description: 'H3 for Get Started section',
  },
});
